const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Converts Google Drive links to proxied URLs via our backend.
 * This avoids CORS/referrer blocking in browsers.
 */
export const convertGoogleDriveLink = (url) => {
  if (!url) return url;

  // Skip if already proxied
  if (url.includes('/api/image-proxy')) return url;

  // Check if it's any form of Google Drive link
  const isDriveLink =
    url.includes('drive.google.com') ||
    url.includes('lh3.googleusercontent.com/d/');

  if (isDriveLink) {
    return `${BACKEND_URL}/api/image-proxy?url=${encodeURIComponent(url)}`;
  }

  return url;
};

export const getImageUrl = (url) => convertGoogleDriveLink(url);
